import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS, useCheckPermissions } from '@/shared';
import { SaveIPV4Component } from '../../shared/components/SaveIPV4Component';
import { LoaderComponent } from '@/shared/components/ui';
import { useGetIpv4 } from '@/shared/actions/erp';

export interface UpdateIPV4PageProps { }

const UpdateIPV4Page: React.FC<UpdateIPV4PageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_change_olt);
  const returnUrlIpv4Page = ROUTER_PATHS.configuracionRED.ipv4Nav;

  const { id } = useParams();
  const { data, isLoading, isRefetching } = useGetIpv4(id!);

  if (isLoading || isRefetching) return null;

  if (!data?.data?.id_ipv4)
    return <Navigate to={returnUrlIpv4Page} />;

  if (isLoading) 
    return <LoaderComponent />

  return <SaveIPV4Component title="Editar IPV4" ipv4={data.data} />;
};

export default UpdateIPV4Page;
